import type { Map as LeafletMap, PointTuple } from 'leaflet';

/**
 * Márgenes para encuadrar resultados SIN que queden debajo de lo que flota
 * sobre el mapa: la barra de filtros arriba (`--filterbar-h`) y, abierta,
 * la lista a la izquierda (`--results-w`). App publica ambas medidas como
 * variables CSS en `.map-area`, que el contenedor de Leaflet hereda.
 */
export function overlayPadding(map: LeafletMap, base = 48): { paddingTopLeft: PointTuple; paddingBottomRight: PointTuple } {
  const cs = getComputedStyle(map.getContainer());
  const top = parseFloat(cs.getPropertyValue('--filterbar-h')) || 0;
  const left = parseFloat(cs.getPropertyValue('--results-w')) || 0;
  const size = map.getSize();
  // Tope: en pantallas chicas lo que flota cubre casi todo el mapa, y un
  // margen mayor que la mitad deja a Leaflet sin espacio para encuadrar.
  return {
    paddingTopLeft: [Math.min(base + left, size.x / 2), Math.min(base + top, size.y / 2)],
    paddingBottomRight: [base, base + 24],
  };
}
